import React from "react";

export class WeightMedium extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="weight-medium">{this.props.children}</span>
        );
    }
}
